// Bed images - New AI generated images (front images)
import bed1_int from "../assets/ai_img/bed1_int.png";
import bed2_int from "../assets/ai_img/bed2_int.png";
import bed3_int from "../assets/ai_img/bed3_int.png";
import bed4_int from "../assets/ai_img/bed4_int.png";
import bed5_int from "../assets/ai_img/bed5_int.png";
import bed6_int from "../assets/ai_img/bed6_int.png";
import bed7_int from "../assets/ai_img/bed7_int.png";
import bed8_int from "../assets/ai_img/bed8_int.png";
import bed9_int from "../assets/ai_img/bed9_int.png";
import bed10_int from "../assets/ai_img/bed10_int.png";
import bedeleven_int from "../assets/ai_img/bedeleven_int.png";
import bed12_int from "../assets/ai_img/bed12_int.png";
import bed13_int from "../assets/ai_img/bed13_int.png";

// Bed images - Original images
import bed1 from "../assets/images/bed1.png";
import bed11 from "../assets/images/bed11.png";
import bed111 from "../assets/images/bed111.png";
import bed2 from "../assets/images/bed2.png";
import bed22 from "../assets/images/bed22.png";
import bed222 from "../assets/images/bed222.png";
import bed3 from "../assets/images/bed3.png";
import bed33 from "../assets/images/bed33.png";
import bed333 from "../assets/images/bed333.png";
import bed4 from "../assets/images/bed4.png";
import bed44 from "../assets/images/bed44.png";
import bed444 from "../assets/images/bed444.png";
import bed5 from "../assets/images/bed5.png";
import bed55 from "../assets/images/bed55.png";
import bed555 from "../assets/images/bed555.png";
import bed6 from "../assets/images/bed6.png";
import bed66 from "../assets/images/bed66.png";
import bed7 from "../assets/images/bed7.png";
import bed77 from "../assets/images/bed77.png";
import bed8 from "../assets/images/bed8.png";
import bed88 from "../assets/images/bed88.png";
import bed9 from "../assets/images/bed9.png";
import bed99 from "../assets/images/bed99.png";
import bed999 from "../assets/images/bed999.png";
import bed10 from "../assets/images/bed10.png";
import bed1010 from "../assets/images/bed1010.png";
import bed101010 from "../assets/images/bed101010.png";
import bedeleven from "../assets/images/bedeleven.png";
import bedeleven1 from "../assets/images/bedeleven1.png";
import bedeleven11 from "../assets/images/bedeleven11.png";
import bed12 from "../assets/images/bed12.png";
import bed1212 from "../assets/images/bed1212.png";
import bed121212 from "../assets/images/bed121212.png";
import bed13 from "../assets/images/bed13.png";
import bed1313 from "../assets/images/bed1313.png";
import bed131313 from "../assets/images/bed131313.png";

// Sofa images - New AI generated images (front images)
import sofa1_int from "../assets/ai_img/Sofa 1.PNG";
import sofa2_int from "../assets/ai_img/Sofa 2.PNG";
import sofa3_int from "../assets/ai_img/Sofa 3.PNG";
import sofa4_int from "../assets/ai_img/Sofa 4.PNG";
import sofa5_int from "../assets/ai_img/Sofa 5.PNG";
import sofa6_int from "../assets/ai_img/Sofa 6.PNG";
import sofa7_int from "../assets/ai_img/Sofa 7.PNG";

// Sofa images - Original images
import sofa1 from "../assets/images/sofa1.png";
import sofa11 from "../assets/images/sofa11.png";
import sofa111 from "../assets/images/sofa111.png";
import sofa2 from "../assets/images/sofa2.png";
import sofa22 from "../assets/images/sofa22.png";
import sofa222 from "../assets/images/sofa222.png";
import sofa3 from "../assets/images/sofa3.png";
import sofa33 from "../assets/images/sofa33.png";
import sofa333 from "../assets/images/sofa333.png";
import sofa4 from "../assets/images/sofa4.png";
import sofa44 from "../assets/images/sofa44.png";
import sofa444 from "../assets/images/sofa444.png";
import sofa5 from "../assets/images/sofa5.png";
import sofa55 from "../assets/images/sofa55.png";
import sofa555 from "../assets/images/sofa555.png";
import sofa6 from "../assets/images/sofa6.png";
import sofa66 from "../assets/images/sofa66.png";
import sofa666 from "../assets/images/sofa666.png";
import sofa7 from "../assets/images/sofa7.png";
import sofa77 from "../assets/images/sofa77.png";
import sofa777 from "../assets/images/sofa777.png";


export const products = [
  {
    id: "cp22-89-bed",
    category: "Beds",
    title: "CP22-89 Bed",
    price: "$649",
    description: "Premium leather bed with high-resilience foam and pine timber frame",
    dimensions: "96×85×46in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Pine Timber Frame"],
    colors: ["Brown", "Black", "Tan"],
    keyFeatures: [
      "76×82in Specification",
      "18in Headboard",
      "12in Mattress",
      "3in Head/Foot Legs"
    ],
    specifications: {
      size: "76×82in",
      externalDimensions: "96×85×46in",
      headboard: "18in",
      mattress: "12in",
      legs: "3in head, 3in foot",
      binding: "Machine molding side"
    },
    images: [bed1_int, bed1, bed11, bed111]
  },
  {
    id: "BY-23-41-bed",
    category: "Beds",
    title: "BY-23-41 Bed",
    price: "$725",
    description: "Premium nanotechnology fabric bed with memory foam",
    dimensions: "98×88×42in",
    materials: ["Nanotechnology Fabric", "Memory Foam", "Pine Timber Frame"],
    colors: ["Brown", "Black", "Gray"],
    keyFeatures: [
      "79×80in Specification",
      "17in Headboard",
      "11in Mattress",
      "3in Head/Foot Legs"
    ],
    specifications: {
      size: "79×80in",
      externalDimensions: "98×88×42in",
      headboard: "17in",
      mattress: "11in",
      legs: "3in head, 3in foot",
      binding: "Machine molding side"
    },
    images: [bed2_int, bed2, bed22, bed222]
  },
  {
    id: "cp24-41-bed",
    category: "Beds",
    title: "CP24-41 Bed",
    price: "$589",
    description: "Premium leather bed with high-resilience foam and pine timber frame",
    dimensions: "91×81×44in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Pine Timber Frame"],
    colors: ["Brown", "Tan", "Charcoal"],
    keyFeatures: [
      "73×78in Specification",
      "19in Headboard",
      "11in Mattress",
      "2in Head/Foot Legs"
    ],
    specifications: {
      size: "73×78in",
      externalDimensions: "91×81×44in",
      headboard: "19in",
      mattress: "11in",
      legs: "2in head, 2in foot",
      binding: "Machine molding side"
    },
    images: [bed3_int, bed3, bed33, bed333]
  },
  {
    id: "cp23-58-bed",
    category: "Beds",
    title: "CP23-58 Bed",
    price: "$799",
    description: "Premium leather bed with high-resilience foam and pine timber frame",
    dimensions: "95×86×40in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Pine Timber Frame"],
    colors: ["Black", "Brown", "Tan"],
    keyFeatures: [
      "75×81in Specification",
      "15in Headboard",
      "9in Mattress",
      "4in Head/Foot Legs"
    ],
    specifications: {
      size: "75×81in",
      externalDimensions: "95×86×40in",
      headboard: "15in",
      mattress: "9in",
      legs: "4in head, 4in foot",
      binding: "Machine molding side"
    },
    images: [bed4_int, bed4, bed44, bed444]
  },
  {
    id: "cp24-60-bed",
    category: "Beds",
    title: "CP24-60 Bed",
    price: "$525",
    description: "Premium leather bed with high-resilience foam and pine timber frame",
    dimensions: "89×79×45in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Pine Timber Frame"],
    colors: ["Brown", "Black", "Walnut"],
    keyFeatures: [
      "71×76in Specification",
      "20in Headboard",
      "13in Mattress",
      "2in Head/Foot Legs"
    ],
    specifications: {
      size: "71×76in",
      externalDimensions: "89×79×45in",
      headboard: "20in",
      mattress: "13in",
      legs: "2in head, 2in foot",
      binding: "Machine molding side"
    },
    images: [bed5_int, bed5, bed55, bed555]
  },
  {
    id: "cp24-04-bed",
    category: "Beds",
    title: "CP24-04 Bed",
    price: "$675",
    description: "Premium leather bed with high-resilience foam and pine timber frame",
    dimensions: "100×90×48in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Pine Timber Frame"],
    colors: ["Tan", "Brown", "Charcoal"],
    keyFeatures: [
      "79×82in Specification",
      "16in Headboard",
      "14in Mattress",
      "3in Head/Foot Legs"
    ],
    specifications: {
      size: "79×82in",
      externalDimensions: "100×90×48in",
      headboard: "16in",
      mattress: "14in",
      legs: "3in head, 3in foot",
      binding: "Machine molding side"
    },
    images: [bed6_int, bed6, bed66]
  },
  {
    id: "cp24-65-bed",
    category: "Beds",
    title: "CP24-65 Bed",
    price: "$845",
    description: "Premium leather bed with high-resilience foam and pine timber frame",
    dimensions: "92×84×41in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Pine Timber Frame"],
    colors: ["Brown", "Black", "Tan"],
    keyFeatures: [
      "74×79in Specification",
      "14in Headboard",
      "8in Mattress",
      "4in Head/Foot Legs"
    ],
    specifications: {
      size: "74×79in",
      externalDimensions: "92×84×41in",
      headboard: "14in",
      mattress: "8in",
      legs: "4in head, 4in foot",
      binding: "Machine molding side"
    },
    images: [bed7_int, bed7, bed77]
  },
  {
    id: "cp24-46-bed",
    category: "Beds",
    title: "CP24-46 Bed",
    price: "$559",
    description: "Premium leather bed with high-resilience foam and pine timber frame"  ,
    dimensions: "97×87×43in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Pine Timber Frame"],
    colors: ["Brown", "Black", "Tan"],
    keyFeatures: [
      "77×80in Specification",
      "17in Headboard",
      "10in Mattress",
      "3in Head/Foot Legs"
    ],
    specifications: {
      size: "77×80in",
      externalDimensions: "97×87×43in",
      headboard: "17in",
      mattress: "10in",
      legs: "3in head, 3in foot",
      binding: "Machine molding side"
    },
    images: [bed8_int, bed8, bed88]
  },
  {
    id: "cp24-18-bed",
    category: "Beds",
    title: "CP24-18 Bed",
    price: "$715",
    description: "Premium leather bed with high-resilience foam and pine timber frame",
    dimensions: "94×82×47in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Pine Timber Frame"],
    colors: ["Brown", "Black", "Tan"],
    keyFeatures: [
      "76×79in Specification",
      "18in Headboard",
      "12in Mattress",
      "2in Head/Foot Legs"
    ],
    specifications: {
      size: "76×79in",
      externalDimensions: "94×82×47in",
      headboard: "18in",
      mattress: "12in",
      legs: "2in head, 2in foot",
      binding: "Machine molding side"
    },
    images: [bed9_int, bed9, bed99, bed999]
  },
  {
    id: "cp24-23-bed",
    category: "Beds",
    title: "CP24-23 Bed",
    price: "$615",
    description: "Premium leather bed with high-resilience foam and pine timber frame",
    dimensions: "88×78×39in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Pine Timber Frame"],
    colors: ["Brown", "Black", "Tan"],
    keyFeatures: [
      "72×75in Specification",
      "15in Headboard",
      "9in Mattress",
      "3in Head/Foot Legs"
    ],
    specifications: {
      size: "72×75in",
      externalDimensions: "88×78×39in",
      headboard: "15in",
      mattress: "9in",
      legs: "3in head, 3in foot",
      binding: "Machine molding side"
    },
    images: [bed10_int, bed10, bed1010, bed101010]
  },
  {
      id: "cp24-27-bed",
    category: "Beds",
    title: "CP24-27 Bed",
    price: "$765",
    description: "Premium leather bed with high-resilience foam and pine timber frame",
    dimensions: "99×89×46in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Pine Timber Frame"],
    colors: ["Brown", "Black", "Tan"],
    keyFeatures: [
      "78×81in Specification",
      "19in Headboard",
      "13in Mattress",
      "4in Head/Foot Legs"
    ],
    specifications: {
      size: "78×81in",
      externalDimensions: "99×89×46in",
      headboard: "19in",
      mattress: "13in",
      legs: "4in head, 4in foot",
      binding: "Machine molding side"
    },
    images: [bedeleven_int, bedeleven, bedeleven1, bedeleven11]
  },
  {
    id: "by24-31-bed",
    category: "Beds",
    title: "BY24-31 Bed",
    price: "$695",
    description: "Premium leather bed with high-resilience foam and pine timber frame",
    dimensions: "90×83×44in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Pine Timber Frame"],
    colors: ["Brown", "Black", "Tan"],
    keyFeatures: [
      "73×77in Specification",
      "16in Headboard",
      "11in Mattress",
      "3in Head/Foot Legs"
    ],
    specifications: {
      size: "73×77in",
      externalDimensions: "90×83×44in",
      headboard: "16in",
      mattress: "11in",
      legs: "3in head, 3in foot",
      binding: "Machine molding side"
    },
    images: [bed12_int, bed12, bed1212, bed121212]
  },
  {
    id: "cp23-72-bed",
    category: "Beds",
    title: "CP23-72 Bed",
    price: "$825",
    description: "Premium leather bed with high-resilience foam and pine timber frame",
    dimensions: "96×85×42in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Larch Wood Frame"],
    colors: ["Brown", "Black", "Tan"],
    keyFeatures: [
      "75×80in Specification",
      "17in Headboard",
      "10in Mattress",
      "4in Head/Foot Legs"
    ],
    specifications: {
      size: "75×80in",
      externalDimensions: "96×85×42in",
      headboard: "17in",
      mattress: "10in",
      legs: "4in head, 4in foot",
      binding: "Machine molding side"
    },
    images: [bed13_int, bed13, bed1313, bed131313]
  },
  {
    id: "by24-56-sofa",
    category: "Sofas",
    title: "BY24-56 Sofa",
    price: "$749",
    description: "Premium leather sofa with high-resilience foam and Russian larch wood frame",
    dimensions: "92×38×36in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Larch Wood Frame"],
    colors: ["Black", "Brown", "Gray"],
    keyFeatures: [
      "3-Seater Design",
      "18in Back Height",
      "26in Seat Depth",
      "4in Leg Height"
    ],
    specifications: {
      size: "3-Seater",
      externalDimensions: "92×38×36in",
      backHeight: "18in",
      seatDepth: "26in",
      legs: "4in",
      binding: "Machine molding side"
    },
    images: [sofa1_int, sofa1, sofa11, sofa111]
  },
  {
    id: "cp23-89-sofa",
    category: "Sofas",
    title: "CP23-89 Sofa",
    price: "$625",
    description: "Premium leather sofa with high-resilience foam and Russian larch wood frame",
    dimensions: "84×35×32in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Larch Wood Frame"],
    colors: ["Brown", "Tan", "Walnut"],
    keyFeatures: [
      "3-Seater Design",
      "15in Back Height",
      "24in Seat Depth",
      "3in Leg Height"
    ],
    specifications: {
      size: "3-Seater",
      externalDimensions: "84×35×32in",
      backHeight: "15in",
      seatDepth: "24in",
      legs: "3in",
      binding: "Machine molding side"
    },
    images: [sofa2_int, sofa2, sofa22, sofa222]
  },
  {
    id: "by23-47-sofa",
    category: "Sofas",
    title: "BY23-47 Sofa",
    price: "$895",
    description: "Premium leather sofa with high-resilience foam and Russian larch wood frame",
    dimensions: "95×40×37in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Larch Wood Frame"],
    colors: ["Brown", "Tan", "Walnut"],
    keyFeatures: [
      "3-Seater Design",
      "20in Back Height",
      "28in Seat Depth",
      "5in Leg Height"
    ],
    specifications: {
      size: "3-Seater",
      externalDimensions: "95×40×37in",
      backHeight: "20in",
      seatDepth: "28in",
      legs: "5in",
      binding: "Machine molding side"
    },
    images: [sofa3_int, sofa3, sofa33, sofa333]
  },
  {
    id: "cp24-92-sofa",
    category: "Sofas",
    title: "CP24-92 Sofa",
    price: "$775",
    description: "Premium leather sofa with high-resilience foam and Russian larch wood frame",
    dimensions: "89×37×34in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Larch Wood Frame"],
    colors: ["Brown", "Black", "Tan"],
    keyFeatures: [
      "3-Seater Design",
      "17in Back Height",
      "25in Seat Depth",
      "3in Leg Height"
    ],
    specifications: {
      size: "3-Seater",
      externalDimensions: "89×37×34in",
      backHeight: "17in",
      seatDepth: "25in",
      legs: "3in",
      binding: "Machine molding side"
    },
    images: [sofa4_int, sofa5, sofa55, sofa555]
  },
  {
    id: "by24-18-sofa",
    category: "Sofas",
    title: "BY24-18 Sofa",
    price: "$685",
    description: "Premium leather sofa with high-resilience foam and Russian larch wood frame",
    dimensions: "86×34×31in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Larch Wood Frame"],
    colors: ["Brown", "Tan", "Walnut"],
    keyFeatures: [
      "3-Seater Design",
      "16in Back Height",
      "23in Seat Depth",
      "2in Leg Height"
    ],
    specifications: {
      size: "3-Seater",
      externalDimensions: "86×34×31in",
      backHeight: "16in",
      seatDepth: "23in",
      legs: "2in",
      binding: "Machine molding side"
    },
    images: [sofa5_int, sofa6, sofa66, sofa666]
  },
  {
    id: "cp23-63-sofa",
    category: "Sofas",
    title: "CP23-63 Sofa",
    price: "$825",
    description: "Premium leather sofa with high-resilience foam and Russian larch wood frame",
    dimensions: "91×39×35in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Larch Wood Frame"],
    colors: ["Brown", "Tan", "Walnut"],
    keyFeatures: [
      "3-Seater Design",
      "19in Back Height",
      "27in Seat Depth",
      "4in Leg Height"
    ],
    specifications: {
      size: "3-Seater",
      externalDimensions: "91×39×35in",
      backHeight: "19in",
      seatDepth: "27in",
      legs: "4in",
      binding: "Machine molding side"
    },
    images: [sofa6_int, sofa7, sofa77, sofa777]
  },
  {
    id: "by23-25-sofa",
    category: "Sofas",
    title: "BY23-25 Sofa",
    price: "$945",
    description: "Premium leather sofa with high-resilience foam and Russian larch wood frame",
    dimensions: "93×36×38in",
    materials: ["Top-grain Leather", "High-resilience Foam", "Russian Larch Wood Frame"],
    colors: ["Brown", "Tan", "Walnut"],
    keyFeatures: [
      "3-Seater Design",
      "18in Back Height",
      "26in Seat Depth",
      "5in Leg Height"
    ],
    specifications: {
      size: "3-Seater",
      externalDimensions: "93×36×38in",
      backHeight: "18in",
      seatDepth: "26in",
      legs: "5in",
      binding: "Machine molding side"
    },
    images: [sofa7_int, sofa4, sofa44, sofa444]
  }
];

export const getProductById = (id) => {
  return products.find(product => product.id === id);
};

